<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">CREATE COURSE CATALOG
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="form-group">
        <label class="col-sm-6 control-label" for="form-field-1">001</label>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="col-sm-4 control-label" for="form-field-1">Points</label>
                <div class="col-sm-8">
                    <input type="text" name="total_point" class="form-control course_module_questions_tot_point" readonly="" value="4">
                </div>
            </div>        
        </div>      
    </div>

    <h4>Module Questions</h4>

    
        
        <div class="module-box module-box-point">

            <label class="question">
                <input type="checkbox" class="course_module" name="module_ids[]" value="704" checked="">
                <div class="checkbox_cls">01 - introduzione</div>
            </label>
    
            
                <div class="form-group">
                    <div class="col-md-6">
                        <label class="question">
                            <input type="checkbox" class="course_module_questions" name="questions_ids[]" value="124" checked="">
                            <div class="checkbox_cls">2+1=</div>
                        </label>
                    </div>
                    <div class="col-md-6">
                        <div class="form-horizontal">
                            <label class="control-label col-md-4">Points</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control course_module_questions_point" name="question_points[124]" digits="true" min="0" value="1">
                            </div>
                        </div>
                    </div>
                </div>

            
                <div class="form-group">
                    <div class="col-md-6">
                        <label class="question">
                            <input type="checkbox" class="course_module_questions" name="questions_ids[]" value="123">
                            <div class="checkbox_cls">1+1=</div>
                        </label>
                    </div>
                    <div class="col-md-6">
                        <div class="form-horizontal">
                            <label class="control-label col-md-4">Points</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control course_module_questions_point" name="question_points[123]" digits="true" min="0" value="">
                            </div>
                        </div>
                    </div>
                </div>

            
        </div>

    
        
        <div class="module-box module-box-point">

            <label class="question">
                <input type="checkbox" class="course_module" name="module_ids[]" value="705" checked="">
                <div class="checkbox_cls">02 - CAD</div>
            </label>
    
            
                <div class="form-group">
                    <div class="col-md-6">
                        <label class="question">
                            <input type="checkbox" class="course_module_questions" name="questions_ids[]" value="125" checked="">
                            <div class="checkbox_cls">10+1=</div>
                        </label>
                    </div>
                    <div class="col-md-6">
                        <div class="form-horizontal">
                            <label class="control-label col-md-4">Points</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control course_module_questions_point" name="question_points[125]" digits="true" min="0" value="">
                            </div>
                        </div>
                    </div>
                </div>

            
        </div>

    
    <h4>Open Answer Questions</h4>

    
    <div class="open_questions_all">
        
<div class="form-group">
    <div class="module-open-cpoint">
        <div class="col-md-1">
            <input type="checkbox" class="course_module_questions course_open_questions" checked="">
            <input type="hidden" name="open_questions_ids[]" value="1">
        </div>

        <div class="col-md-5">
          <textarea class="form-control" rows="4" name="open_questions_titles[]" id="open_questions_titles_16234348502060425972" required="">          descrivi te stesso
</textarea>
        </div>

        <div class="col-md-6">
            <div class="form-horizontal">
                <label class="control-label col-md-4">Point</label>
                <div class="col-md-8">
                    <input type="text" class="form-control course_module_questions_point" name="open_questions_points[]" digits="true" min="0" value="3">
                </div>
            </div>
        </div>
        <div class="trash_cls">
            <a href="javascript:void(0);" class="btn btn-default pull-right delete_open_qtn">
                <i class="fa fa-trash-o"></i>
            </a>
        </div>
    </div>
</div>

            </div>

    

    <div class="form-group text-center">
        <button type="button" class="btn btn-purple add_open_qtn">add open answer question                    </button>
    </div>

    <div class="module-box form-horizontal">
      <div class="form-group has-success">
        <label class="col-sm-3 question" for="form-field-3">Notes</label>
        <div class="col-sm-8">
          <textarea class="form-control" rows="4" name="notes">          </textarea>
        </div>
      </div>
    </div>



</div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ generalLang.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>